import * as React from 'react';
import { Link } from 'react-router-dom';
import { CardEvent, Bus } from 'src/store/events/types';
import { Availability, AvailabilityDots } from './AvailabilityDots/AvailabilitsDots';

import './Event.scss';
import { User } from 'src/store/user/types';

interface Props {
  key: number;
  currentPath: string;
  event: CardEvent;
  user: User;
}

export const calculateActive = (quota: number | null, bookedBy: number) => {
  if (quota === null) {
    return Availability.green;
  } else {
    const partLength = bookedBy;
    const per = Math.floor(partLength * 0.25);
    if (partLength < quota - per) {
      return Availability.green;
    }
    if (partLength >= quota - per && partLength < quota) {
      return Availability.yellow;
    }
    if (partLength >= quota) {
      return Availability.red;
    }
    return Availability.red;
  }
};

export const EventListItem: React.SFC<Props> = ({ key, currentPath, event, user }: Props) => (
  <div className="eventItem" key={key}>
    <Link className={event.hidden ? 'isHidden' : ''} to={currentPath + '/' + event.id}>
      {event.title}
    </Link>
    <AvailabilityDots active={calculateActive(event.quota, event.bookedBy)} hidden={false} />
    {user.role.canUpdateEvents && event.buses && event.buses.length > 0 && busDots(event.buses)}
  </div>
);

const busDots = (buses: Bus[]) => {
  return buses.map((b: Bus, i: number) => {
    if (b.bookedBy !== undefined) {
      return (
        <React.Fragment key={i}>
          <AvailabilityDots
            active={calculateActive(b.quota, b.bookedBy)}
            hidden={b.hidden}
            className="small"
          />
        </React.Fragment>
      );
    }
    return null;
  });
};



// WEBPACK FOOTER //
// ./src/components/Week/Event/Event.tsx